import { render, staticRenderFns } from "./MyReviews.vue?vue&type=template&id=69520f03&scoped=true&"
import script from "./MyReviews.vue?vue&type=script&lang=js&"
export * from "./MyReviews.vue?vue&type=script&lang=js&"
import style0 from "./MyReviews.vue?vue&type=style&index=0&id=69520f03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69520f03",
  null
  
)

export default component.exports